let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kHuTn")).then(() => parcelRequire('93jah'));